var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJouwmakelaarOnlineLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 739.2 115.1",
    style: {
      enableBackground: "new 0 0 739.2 115.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#3452FF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M504.9,95.6H15.8C8,95.6,1.6,89.2,1.6,81.4V15.2C1.6,7.4,8,1,15.8,1h489.1c7.8,0,14.2,6.3,14.2,14.2v66.2   C519.1,89.2,512.8,95.6,504.9,95.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7,112.9l-21.4-21.4c-1.5-1.5-1.5-3.9,0-5.4l21.4-21.4c1.5-1.5,3.9-1.5,5.4,0l21.4,21.4c1.5,1.5,1.5,3.9,0,5.4   l-21.4,21.4C261.6,114.4,259.2,114.4,257.7,112.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.8,27.8h10.3V57c0,9.2-5.5,14.1-13.9,14.1c-8.6,0-14.7-5.1-14.7-14.8h10.2c0,3.7,1.6,5.4,4.2,5.4    c2.5,0,3.9-1.6,3.9-4.8V27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.6,71.1c-9.8,0-17.3-6.7-17.3-17.5c0-10.8,7.6-17.5,17.4-17.5c9.8,0,17.4,6.7,17.4,17.5    C97.1,64.4,89.4,71.1,79.6,71.1z M79.6,62.1c3.7,0,7.1-2.7,7.1-8.5c0-5.8-3.4-8.5-7-8.5c-3.7,0-7,2.7-7,8.5    C72.7,59.3,75.9,62.1,79.6,62.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.6,70.6h-10.3V66c-2,2.9-5.6,5-10.1,5c-7.7,0-13-5.4-13-14.5V36.6h10.2v18.5c0,4.6,2.6,7.2,6.4,7.2    c4,0,6.5-2.6,6.5-7.2V36.6h10.3V70.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.5,36.6h10.3l4.7,24.3l5.6-24.3H171l5.7,24.2l4.7-24.2h9.7l-9.1,34h-11.3l-5.3-22.1l-5.5,22.1h-11.3    L139.5,36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.1,52.1c0-4.5-2.5-6.9-6.4-6.9c-3.9,0-6.4,2.4-6.4,6.9v18.5h-10.2V52.1c0-4.5-2.5-6.9-6.4-6.9    c-3.9,0-6.4,2.4-6.4,6.9v18.5H195v-34h10.3v4.3c2-2.7,5.4-4.6,9.8-4.6c5,0,9.1,2.3,11.4,6.3c2.2-3.6,6.4-6.3,11.3-6.3    c8.3,0,13.6,5.4,13.6,14.5v19.9h-10.2V52.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.2,36.1c5,0,8.5,2.3,10.3,5.3v-4.8h10.3v34h-10.3v-4.8c-1.9,3-5.4,5.3-10.4,5.3    c-8.2,0-14.7-6.8-14.7-17.6S263,36.1,271.2,36.1z M274.2,45.2c-3.8,0-7.3,2.9-7.3,8.4c0,5.4,3.5,8.5,7.3,8.5c3.9,0,7.3-3,7.3-8.4    C281.5,48.2,278.1,45.2,274.2,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M299.2,25.5h10.3v24.9l10.1-13.8h12.7l-13.9,17.1l14,16.9h-12.7l-10.2-14.3v14.3h-10.3V25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M351.2,71.1c-9.8,0-16.9-6.7-16.9-17.5c0-10.8,7-17.5,16.9-17.5c9.8,0,16.7,6.6,16.7,16.9c0,1-0.1,2-0.2,3    h-23.2c0.4,4.4,3.1,6.5,6.4,6.5c2.9,0,4.5-1.5,5.3-3.3h10.9C365.5,66,359.5,71.1,351.2,71.1z M344.5,50.3h12.8    c0-3.7-2.9-5.9-6.3-5.9C347.7,44.5,345.1,46.5,344.5,50.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373.3,25.5h10.3v45.1h-10.3V25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M403.7,36.1c5,0,8.5,2.3,10.3,5.3v-4.8h10.3v34H414v-4.8c-1.9,3-5.4,5.3-10.4,5.3c-8.2,0-14.7-6.8-14.7-17.6    S395.5,36.1,403.7,36.1z M406.7,45.2c-3.8,0-7.3,2.9-7.3,8.4c0,5.4,3.5,8.5,7.3,8.5c3.9,0,7.3-3,7.3-8.4    C414,48.2,410.6,45.2,406.7,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M444.4,36.1c5,0,8.5,2.3,10.3,5.3v-4.8H465v34h-10.3v-4.8c-1.9,3-5.4,5.3-10.4,5.3c-8.2,0-14.7-6.8-14.7-17.6    S436.2,36.1,444.4,36.1z M447.4,45.2c-3.8,0-7.3,2.9-7.3,8.4c0,5.4,3.5,8.5,7.3,8.5c3.9,0,7.3-3,7.3-8.4    C454.8,48.2,451.3,45.2,447.4,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M482.7,70.6h-10.3v-34h10.3v5.7c2.3-3.6,6-6,10.5-6v11h-2.8c-4.9,0-7.7,1.7-7.7,7.6V70.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M539.4,71.6c-3.7,0-6.1-2.5-6.1-5.5c0-3.2,2.5-5.6,6.1-5.6c3.6,0,6.1,2.5,6.1,5.6    C545.4,69.1,543,71.6,539.4,71.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566.7,71.6c-9.8,0-17.3-6.6-17.3-17.2s7.6-17.2,17.4-17.2c9.8,0,17.4,6.6,17.4,17.2S576.6,71.6,566.7,71.6z     M566.7,62.7c3.7,0,7.1-2.7,7.1-8.3c0-5.7-3.4-8.3-7-8.3c-3.7,0-7,2.6-7,8.3C559.9,60,563,62.7,566.7,62.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M612.8,52.9c0-4.6-2.5-7.1-6.4-7.1c-3.9,0-6.4,2.5-6.4,7.1v18.2h-10.3V37.6H600v4.4c2-2.8,5.6-4.8,10.1-4.8    c7.7,0,12.9,5.3,12.9,14.3v19.6h-10.2V52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M630.2,26.7h10.3v44.4h-10.3V26.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M646.9,28.6c0-3.1,2.5-5.6,6.1-5.6c3.6,0,6.1,2.5,6.1,5.6c0,3.1-2.5,5.5-6.1,5.5    C649.4,34.1,646.9,31.7,646.9,28.6z M647.9,37.6h10.3v33.5h-10.3V37.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M688.7,52.9c0-4.6-2.5-7.1-6.4-7.1c-3.9,0-6.4,2.5-6.4,7.1v18.2h-10.3V37.6h10.3v4.4c2-2.8,5.6-4.8,10.1-4.8    c7.7,0,12.9,5.3,12.9,14.3v19.6h-10.2V52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M720.9,71.6C711,71.6,704,65,704,54.4s7-17.2,16.9-17.2c9.8,0,16.7,6.5,16.7,16.7c0,1-0.1,2-0.2,3h-23.2    c0.4,4.4,3.1,6.4,6.4,6.4c2.9,0,4.5-1.4,5.3-3.2h10.9C735.2,66.5,729.2,71.6,720.9,71.6z M714.2,51.1h12.8c0-3.7-2.9-5.8-6.3-5.8    C717.4,45.4,714.8,47.4,714.2,51.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJouwmakelaarOnlineLogo);
export default __webpack_public_path__ + "static/media/jouwmakelaar-online-logo.b97319aa9ae160d37e4171619321e669.svg";
export { ForwardRef as ReactComponent };